<template>

    <v-card class="pa-6 ma-md-10 bg-white-show-through">

        <!-- title -->
        <v-card-title class="card-title">
            <v-icon large class="indigo--text mr-3">{{$t('client.location_details.icon')}}</v-icon> {{ $t('client.location_details.title')}}
        </v-card-title>

        <v-divider class="my-4"></v-divider>

        <v-card-text>

            <v-row>

                <v-col v-if="error" cols="12">
                    <AppAlert :alert="error" />
                </v-col>

                <v-skeleton-loader v-if="isLoading" v-bind="attrs" type="date-picker"></v-skeleton-loader>

                <v-col v-if="!isLoading && location" cols="12">
                    <v-form ref="form">
                        <v-row>

                            <!-- car -->
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field
                                    :value="location.car.model+' ('+location.car.immat+')'"
                                    :label="$t('client.location_details.car_label')"
                                    readonly>
                                </v-text-field>

                            </v-col>

                            <!-- start time -->
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field
                                    v-model="location.startTimeString"
                                    :label="$t('client.location_details.start_time_label')"
                                    readonly>
                                </v-text-field>
                            </v-col>

                            <!-- end time -->
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field
                                    v-model="location.endTimeString"
                                    :label="$t('client.location_details.end_time_label')"
                                    readonly>
                                </v-text-field>
                            </v-col>

                            <!-- status -->
                            <v-col cols="12" md="4" sm="6">
                                <b>{{location.car.agency.name}}</b> {{location.car.agency.address}} <br>  {{location.car.agency.phoneNumbers}}
                            </v-col>

                            <!-- Montant -->
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field
                                    :value="location.montantTTC+location.montantTTCSupp+'  ('+location.montantTTC+' + '+location.montantTTCSupp+ ')'"
                                    :label="$t('client.location_details.montant_label')"
                                    readonly>
                                </v-text-field>
                            </v-col>

                        </v-row>

                        <v-divider class="my-4"/>

                        <!-- paiements -->
                        <v-row >
                            <v-col cols="12">
                                <h4><v-icon class="mr-2">mdi-dots-horizontal</v-icon> <a @click="displayPayments=!displayPayments">{{$t('client.location_details.paiements.title')}}</a></h4>
                                <v-divider class="my-4" />
                                <v-simple-table v-if="displayPayments">
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left">{{ $t("client.location_details.paiements.label")}}</th>
                                            <th class="text-left">{{ $t("client.location_details.paiements.type")}}</th>
                                            <th class="text-left">{{ $t("client.location_details.paiements.status")}}</th>
                                            <th class="text-left">{{ $t("client.location_details.paiements.montant")}}</th>
                                            <th class="text-left">{{ $t("client.location_details.paiements.moyen")}}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(paiement, i) in location.paiements" :key="i" class="py-2">
                                            <td>{{paiement.label}}</td>
                                            <td>{{paiement.type}}</td>
                                            <td>{{paiement.status}}</td>
                                            <td>{{paiement.montant}}</td>
                                            <td>{{paiement.moyen}}</td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>


                        <v-row >
                            <v-col cols="12">
                                <h4><v-icon class="mr-2">mdi-dots-horizontal</v-icon> <a @click="displayDocuments=!displayDocuments">Documents</a></h4>
                                <v-divider class="my-4" />
                                <v-simple-table v-if="displayDocuments">
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left">{{ $t("client.location_details.file")}}</th>
                                            <th class="text-left">Type</th>
                                            <th>Date</th>
                                            <th class="text-left">{{ $t("client.location_details.download")}}</th>
                                        </tr>
                                        </thead>
                                                    <tbody>
                                        <tr v-for="(file, i) in location.files" :key="i" class="py-2">
                                            <td>{{file.name}}</td>
                                            <td>{{file.type}}</td>
                                            <td>{{file.created |formatDateTime}}</td>
                                            <td><a target="_blank" :href="'/api/v1/location/file?locationId='+location.id+'&fileId='+ file.id"><v-icon class="mr-2">mdi-download</v-icon> </a></td>
                                        </tr>

                                        <tr v-for="(file, i) in location.car.files " :key="i" class="py-2" >
                                            <td>{{file.name}}</td>
                                            <td>{{file.type}}</td>
                                            <td>{{file.created |formatDateTime}}</td>
                                            <td><a target="_blank" :href="'/api/v1/location/file?locationId='+location.id+'&fileId='+ file.id"><v-icon class="mr-2">mdi-download</v-icon> </a></td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4" />

                        <v-btn tile color="success" :to="{name: 'locationsList'}">
                            <v-icon class="mr-2">mdi-keyboard-backspace</v-icon> {{$t('client.location_details.back_btn_label')}}
                        </v-btn>
                    </v-form>
                </v-col>

            </v-row>

        </v-card-text>

    </v-card>

</template>

<script>
import {LocationsApi} from "@/shared/services";

export default {
    name: 'LocationDetails',
    data(){
        return {
            location: null,
            isLoading: false,
            displayPayments : false,
            displayDocuments : false,
            error: null,
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2
            },
            paiements: [],
            isPaiementsLoading: false,
            paiementsError: null
        }
    },
    methods: {
        getDetails(){
            this.isLoading = true;
            this.error = null;
            LocationsApi.getLocationDetails(this.$route.params.id)
                .then(location => {
                    this.location = location;
                    this.isPaiementsLoading = false;
                    this.paiementsError = null;
                })
                .catch(error => this.error = error)
                .finally(() => this.isLoading = false);
        }
    },
    mounted() {
        this.getDetails();
    }
}
</script>
